/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { __awaiter } from "tslib";
import { addStyles } from "@tedivo/tedivo-form";
import { removeChildren } from "@tedivo/tedivo-dom-helpers";
const styles = `
   sl-dialog::part(body) {
    overflow: var(--dialog-body-overflow, auto);
    width: 100%;
  }
`;
export class IntegratedDialog {
    get name() {
        return this.nameStr;
    }
    set name(v) {
        this.nameStr = v;
        if (this.internalDialog) {
            this.internalDialog.setAttribute("name", v);
        }
    }
    constructor(options) {
        this.buttons = [];
        this.nameStr = "";
        this.onButtonClicked = undefined;
        this.onDismissed = undefined;
        this.options = options;
    }
    updateOptions(options) {
        this.options = Object.assign(Object.assign({}, this.options), options);
        return this;
    }
    get isOpen() {
        var _a;
        return ((_a = this.internalDialog) === null || _a === void 0 ? void 0 : _a.open) || false;
    }
    show(title, message) {
        var _a, _b;
        const { dialog } = this.createDialog();
        dialog.label = title;
        const btnActionToFocus = (_b = (_a = this.options.buttonsAttrs) === null || _a === void 0 ? void 0 : _a.find((btnAttrs) => btnAttrs.autofocus)) === null || _b === void 0 ? void 0 : _b.value;
        if (btnActionToFocus) {
            const btn = this.buttons.find((f) => f.dataset["action"] === btnActionToFocus);
            if (btn) {
                btn.setAttribute("autofocus", "true");
            }
        }
        if (typeof message === "string") {
            this.htmlContent.innerHTML = message;
        }
        else {
            removeChildren(this.htmlContent);
            this.htmlContent.appendChild(message);
        }
        dialog.show();
        return this;
    }
    setButtonEnabled(action, enabled) {
        const btn = this.buttons.find((f) => f.dataset["action"] === action);
        if (btn)
            btn.disabled = !enabled;
    }
    getButton(action) {
        return this.buttons.find((f) => f.dataset["action"] === action);
    }
    createDialog() {
        var _a;
        if (this.internalDialog) {
            return { dialog: this.internalDialog };
        }
        const dialog = document.createElement("sl-dialog");
        dialog.appendChild(addStyles(styles));
        if (this.nameStr)
            dialog.setAttribute("name", this.nameStr);
        dialog.className = "integrated-dialog";
        this.htmlContent = document.createElement("div");
        const buttonsHolder = document.createElement("div");
        buttonsHolder.className = "dialog-buttons-holder";
        buttonsHolder.slot = "footer";
        if (this.buttonsExtraNode) {
            buttonsHolder.appendChild(this.buttonsExtraNode);
        }
        if (this.headerActionsExtraNode) {
            this.headerActionsExtraNode.slot = "header-actions";
            dialog.appendChild(this.headerActionsExtraNode);
        }
        if (this.options.width) {
            dialog.style.setProperty("--width", this.options.width);
        }
        if (this.options.maxWidth) {
            dialog.style.setProperty("--dialog-max-width:", this.options.maxWidth);
        }
        if (this.options.bodyOverflow) {
            dialog.style.setProperty("--dialog-body-overflow", this.options.bodyOverflow);
        }
        const onClicked = (value, btn) => __awaiter(this, void 0, void 0, function* () {
            if (this.onButtonClicked) {
                const res = yield this.onButtonClicked(value, btn);
                if (res === false)
                    return;
            }
            dialog.hide();
        });
        (_a = this.options.buttonsAttrs) === null || _a === void 0 ? void 0 : _a.forEach((btnAttrs) => {
            const btn = document.createElement("sl-button");
            btn.variant = btnAttrs.variant || "primary";
            btn.outline = btnAttrs.outlined || false;
            btn.tabIndex = 0;
            btn.type = btnAttrs.type || "button";
            btn.dataset["action"] = btnAttrs.value;
            btn.innerHTML = btnAttrs.label;
            btn.addEventListener("click", () => onClicked(btnAttrs.value, btn), false);
            buttonsHolder.appendChild(btn);
            this.buttons.push(btn);
            if (btnAttrs.icon) {
                const icon = document.createElement("sl-icon");
                icon.name = btnAttrs.icon;
                icon.slot = "prefix";
                btn.appendChild(icon);
            }
        });
        dialog.appendChild(this.htmlContent);
        dialog.appendChild(buttonsHolder);
        this.options.parentNode.appendChild(dialog);
        dialog.addEventListener("sl-request-close", (event) => {
            if (event.target !== dialog)
                return;
            if (this.options.preventClose ||
                (this.options.preventDefaultClose &&
                    event.detail.source === "overlay")) {
                event.preventDefault();
            }
        });
        if (this.options.removeDialogWhenHidden) {
            dialog.addEventListener("sl-after-hide", (event) => {
                var _a;
                if (event.target !== dialog)
                    return;
                dialog.remove();
                this.internalDialog = undefined;
                (_a = this.onDismissed) === null || _a === void 0 ? void 0 : _a.call(this);
            });
        }
        this.internalDialog = dialog;
        return { dialog };
    }
    hide() {
        var _a;
        (_a = this.internalDialog) === null || _a === void 0 ? void 0 : _a.hide();
    }
}
export function createSimpleAlert({ title, message, width, onOk, closeLabel, }) {
    const dialog = new IntegratedDialog({
        parentNode: document.body,
        width,
        removeDialogWhenHidden: true,
        buttonsAttrs: [
            {
                value: "ok",
                label: closeLabel,
                type: "button",
                variant: "primary",
                autofocus: true,
            },
        ],
    });
    dialog.onButtonClicked = () => {
        dialog.hide();
        if (onOk)
            onOk();
    };
    dialog.show(title, message);
}
